<template>
  <div class="col-lg-8 offset-lg-2 page">
    <div class="row form-container">
      <!-- head: filter and sorter -->
      <item-filter :arrayToFilter="allItems" :type="type" @update-keywords="updateKeywords"
        @filterArray="updateFilterResults" />
      <item-sorter v-if="type === types.procedures || type === types.procedureKinds" :arrayToSort="filteredItems"
        :pKinds="type === types.procedureKinds" @sortArray="updateSortResults" />
      <div v-if="type == types.procedures || type === types.procedureKinds" class="procedureSwitch">
        <text>Sort by Procedure Kind</text>
        <label class="switch">
          <input type="checkbox" @change="switchType()">
          <span class="slider round"></span>
        </label>
      </div>
    </div>

    <div class="d-flex justify-content-end align-items-center mb-3">
      <button v-if="type == types.allergy" class="allergy-btn" @click="showAllergy">Add allergy</button>
      Items Per Page
      <select v-model="countPerPage" class="form-select align-self-center mx-3">
        <option :value="5">5</option>
        <option :value="10">10</option>
        <option :value="15">15</option>
        <option :value="20">20</option>
      </select>

      <pagination-info ref="pagination-info" />

      <pagination ref="pagination" @pagination:change-page="paginate" />
    </div>

    <!-- legend: procedure only -->
    <small v-if="type === types.procedures || type === types.procedureKinds" class="mb-md-2 md-2 mb-md-3 mb-3">
      <font-awesome-icon icon="plus-circle" class="mr-md-1 mr-1" />
      <span>ADD TO WATCH LIST</span>
    </small>

    <div class="void-filler" v-if="empty">
      <span>No items to see here.</span>
    </div>
    <!-- body: list of items -->
    <ul v-if="type === types.procedureKinds">
      <li v-for="(itemsGroupedByCode, index) in pageItems" :key="idKinds(itemsGroupedByCode) + index"
        class="text-capitalize list__item">
        <div>
          <togglable-caret-header :data-bs-target="'#' + idKinds(itemsGroupedByCode) + index" :showCaret="true"
            :id="'name-' + itemsGroupedByCode.procName + index" class="card-header header__link"
            data-bs-toggle="collapse">
            <a role="button" :id="'button-' + itemsGroupedByCode.procName + index"
              :data-tooltip="itemsGroupedByCode.procName">
              <text-highlight :queries="keywords" class="header__link__desc">
                {{ truncate(itemsGroupedByCode.procName) }}
              </text-highlight>
            </a>
          </togglable-caret-header>
          <watch-button-procedure :procCcd="itemsGroupedByCode.procedures[0].codes[0]"
            :procIds="getAllIds(itemsGroupedByCode)" />
          <!-- accordion body: items grouped by the same code, but different dates -->
          <div :id="idKinds(itemsGroupedByCode) + index" class="collapse">
            <text-highlight :queries="keywords">
              {{ itemsGroupedByCode.procName }}
            </text-highlight>
            <ul> <!-- style="margin: 0px -15px -15px;" -->
              <li v-for="(prod, ind) in itemsGroupedByCode.procedures" :key="id(prod) + ind"
                class="text-capitalize list__item">
                <div>
                  <togglable-caret-header :data-bs-target="'#' + id(prod) + ind + index" :showCaret="true" class="__link"
                    data-bs-toggle="collapse">
                    <a role="button">
                      <text-highlight :queries="keywords" class="header__link__desc">
                        {{ getDate(prod) }}
                        <!-- {{ prod.lo || '' }} -- {{ prod.hi || '' }} -->
                      </text-highlight>
                    </a>
                  </togglable-caret-header>
                  <!-- accordion body: items grouped by the same code, but different dates -->
                  <div :id="id(prod) + ind + index" class="collapse">
                    <item-detail :keywords="keywords" :item="prod" :type="types.procedures" />
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
    <ul v-else>
      <template v-if="this.type == types.allergy">
        <li v-for="(allergy, index) in manualAllergies" :key="'manual'+index" class="text-capitalize list__item">
          <div>
            <span> {{ allergy.name }}</span>
          </div>
        </li>
      </template>
      <li v-for="(itemsGroupedByCode, index) in pageItems" :key="id(itemsGroupedByCode) + index"
        class="text-capitalize list__item">
        <div>
          <togglable-caret-header :data-bs-target="'#' + id(itemsGroupedByCode) + index" :showCaret="true"
            class="card-header header__link" data-bs-toggle="collapse">
            <a role="button" :data-tooltip="getDescription(itemsGroupedByCode)">
              <text-highlight v-if="type === types.providers" :queries="keywords" class="header__link__desc">
                {{ getTaxonomyDescription(itemsGroupedByCode) }}
              </text-highlight>
              <text-highlight v-else :queries="keywords" class="header__link__desc">
                {{ type === types.procedures ? truncate(getDescription(itemsGroupedByCode), itemsGroupedByCode) : (type
                  === types.directives ? truncateDirective(getDescription(itemsGroupedByCode)) :
                  getDescription(itemsGroupedByCode)) }}
              </text-highlight>
              <span class="nameDate">{{ (type === types.reports || type === types.directives) ? itemsGroupedByCode.when :
                getDate(itemsGroupedByCode) }}</span>
            </a>
          </togglable-caret-header>

          <!-- accordion body: items grouped by the same code, but different dates -->
          <div :id="id(itemsGroupedByCode) + index" class="collapse">
            <div v-if="type === types.procedures"> {{ getDescription(itemsGroupedByCode) }} </div>
            <item-detail :keywords="keywords" :item="itemsGroupedByCode" :type="type" />
          </div>

        </div>

      </li>
    </ul>
    <div id="add-allergy-modal" class="add-allergy-modal" :style="{ 'display': 'none' }">
      <div class="inner-text-modal">
        <div class="form-group2">
          <label>Add an allergy</label>
          <input type="text" required v-model="newAllergy" class="form-control2" />
        </div>
        <div class="btn-group">
          <button type="submit" class="btn btn-primary" @click="addAllergy">Confirm</button>
          <button type="button" class="btn btn-secondary" @click="closeAllergy">Cancel</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import FilterPage from '@/components/private-layouts/_partials/filter/FilterPage';
import SortPage from '@/components/private-layouts/_partials/sort/SortPage';
import ItemDetailPage from '@/components/includes/ItemDetailPage';
import WatchButtonProcedure from '@/components/private-layouts/_partials/watch/WatchButtonProcedure';
import $ from "jquery";
import types from '@/data/types';
import { getItemsByType } from '@/data/getters';
import { mapGetters } from 'vuex';
import TogglableCaretHeader from '@/components/includes/TogglableCaretHeader';
import Pagination from '@/components/includes/pagination/Pagination';
import PaginationInfo from '@/components/includes/pagination/PaginationInfo';
import { getDescByCcd } from "../../data/getters";
import WatchButtonMeasure from '../private-layouts/_partials/watch/WatchButtonMeasure.vue';
import axios from 'axios'
import { CURR_API, OTHER_API } from "@/constants/apis";

export default {
  name: 'filterable-sortable-page',
  components: {
    'item-filter': FilterPage,
    'item-sorter': SortPage,
    'item-detail': ItemDetailPage,
    'watch-button-procedure': WatchButtonProcedure,
    'togglable-caret-header': TogglableCaretHeader,
    Pagination,
    PaginationInfo,
    WatchButtonMeasure
  },
  data() {
    return {
      allItems: [],
      filteredItems: [],
      keywords: [],
      type: null,
      types,
      countPerPage: 10,
      pageItems: [],
      newAllergy: '',
      manualAllergies: []
    };
  },
  computed: {
    ...mapGetters('login', {
      allData: 'getAllData'
    }),
    empty() {
      // console.log(this.pageItems)
      return !this.filteredItems || this.filteredItems.length < 1;
    },
    totalPage() {
      return Math.ceil(this.filteredItems.length / this.countPerPage);
    }
  },
  watch: {
    allData() {
      this.refresh();
    },
    $route(to, from) {
      this.refresh();
    },
    countPerPage() {
      this.refresh();
    },
  },
  methods: {
    async getAllergies() {
      let content = {
        "Allergy": {
          "API_Meth": "GetAllergies",
          "pid": this.allData.patient.externId
        }
      }
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          this.manualAllergies = res.data.allergies
        });
    },
    id(items) {
      return 'collapse' + this.type +
        +[...items.codes, ...items.cdas].join('-')
        + items.lo + items.hi;
    },

    idKinds(items) {
      return 'collapse'
        + [...items.procedures[0].codes, ...items.procedures[0].cdas].join('-')
        + items.procedures[0].lo + items.procedures[0].hi
    },

    shorten(str, len) {
      if (str.length < len)
        return str
      return str.substr(0, str.lastIndexOf(' ', len))
    },

    truncateDirective(str) {
      if (str.toLowerCase().includes('advance care planning')) return 'Advance Care Planning'
      return str
    },

    truncate(str, items) {
      let dateHolder = 0
      if (this.type != types.procedureKinds) {
        let dateName = "(" + (items.lo || '') + "--" + (items.hi || '') + ")"
        dateHolder = dateName.length
      }
      for (let char of str) {
        if (char == ':') {
          return this.shorten(str.split(':')[0], 67 - dateHolder) + '...'
        }
        if (char == ';') {
          return this.shorten(str.split(';')[0], 67 - dateHolder) + '...'
        }
        if (char == ',') {
          return this.shorten(str.split(',')[0], 67 - dateHolder) + '...'
        }
        if (char == '.') {
          return this.shorten(str.split('.')[0], 67 - dateHolder) + '...'
        }
      }
      return this.shorten(str, 67 - dateHolder) + '...'
    },

    getDate(prod) {
      let date1 = prod.lo || ''
      let date2 = prod.hi || ''
      if (date1 === '' && date2 === '')
        return ''
      else if (date1 == '')
        return '-- ' + date2
      else if (date2 == '')
        return date1
      else
        return date1 + ' -- ' + date2
    },

    getAllIds(items) {
      let ans = []
      for (let proc of items.procedures) {
        ans.push(...proc.ids)
      }
      return ans
    },

    // updateName(itemsGroupedByCode, index) {
    //   // document.getElementById('button-'+items.procName+index).innerText = 
    //   // document.getElementById('button-'+items.procName+index).innerText === items.procName ?
    //   // this.truncate(items.procName) :
    //   // items.procName
    //   let dropdownCheck = document.getElementById('name-'+itemsGroupedByCode.procName+index).attributes['aria-expanded']
    //   let buttonName = document.getElementById('button-'+itemsGroupedByCode.procName+index)
    //   if (!dropdownCheck || dropdownCheck.value == 'false'){
    //     buttonName.innerText = itemsGroupedByCode.procName
    //     console.log(document.getElementById('button-'+itemsGroupedByCode.procName+index))
    //   }
    //   else{
    //     buttonName.innerText = this.truncate(itemsGroupedByCode.procName)
    //     console.log(document.getElementById('button-'+itemsGroupedByCode.procName+index))
    //   }
    // },

    updateKeywords(payload) {
      this.keywords = payload;
      //      this.refresh();
    },

    updateSortResults(payload) {
      this.filteredItems = payload;
      //      this.refresh();
      this.paginate(1)
    },

    updateFilterResults(payload) {
      this.filteredItems = payload;
      //      this.refresh();
      this.paginate(1);
    },

    switchType() {
      if (this.type == types.procedures) {
        this.type = types.procedureKinds
      }
      else if (this.type == types.procedureKinds) {
        this.type = types.procedures
      }
      this.filteredItems = this.allItems = getItemsByType(this.type, this.allData)
      this.paginate(1)
      // console.log(this.pageItems)
      // console.log(this.allData)
    },
    refresh() {
      const path = this.$route.path;
      let sp = path.split('/');
      let type = sp[1];
      this.type = this.types[type];
      this.filteredItems = this.allItems = getItemsByType(this.type, this.allData);
      if (this.type === types.directives) {
        this.filteredItems = this.filteredItems.filter(item => item.category == "Advance directives (narrative)")
      }
      // console.log(this.filteredItems)
      // this.keywords = []; // TODO: clear input field in FilterPage 
      this.paginate(1);
    },
    getTaxonomyDescription(items) {
      return items.description;
    },
    getDescription(items) {
      let result = '';
      if (this.type === types.providers)
        result = this.getTaxonomyDescription(items);
      else
        result = getDescByCcd(items.codes[0], this.allData);
      return result;
    },
    getCcdDescriptionById(id) {
      return getDescByCcd(id, this.allData);
    },
    pageFactory(page) {
      const pagination = {};
      pagination.from = this.countPerPage * (page - 1) + 1;
      pagination.to = Math.min(this.filteredItems.length, this.countPerPage * page);
      pagination.currentPage = page;
      pagination.total = this.filteredItems.length;
      pagination.totalPage = this.totalPage;

      this.$refs['pagination-info'].setPaginationData(pagination);
      this.$refs['pagination'].setPaginationData(pagination);
    },
    paginate(page) {
      if (page < this.totalPage) {
        this.pageItems = this.filteredItems.slice(this.countPerPage * (page - 1), this.countPerPage * page);
        this.pageFactory(page);
      }

      if (page == this.totalPage) {
        this.pageItems = this.filteredItems.slice(this.countPerPage * (page - 1));
        this.pageFactory(page);
      }
    },
    async addAllergy() {
      if (!this.newAllergy.trim()){
        alert("Please insert an allergy name to add.")
        return
      }
      let content = {
        "Allergy": {
          "API_Meth": "AddAllergies",
          "pid": this.allData.patient.externId,
          "name": this.newAllergy
        }
      }
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.status == "Inserted"){
            this.getAllergies()
            this.closeAllergy()
          }
          else {
            alert("Error adding an allergy. Please contact an administrator.")
          }
        });
    },
    closeAllergy() {
      this.newAllergy = ''
      $("#add-allergy-modal").css("display", "none")
    },
    showAllergy() {
      $("#add-allergy-modal").css("display", "flex")
    },
  },

  mounted() {
    this.refresh();
    if (this.type == types.allergy){
      this.getAllergies()
    }
  },

  beforeDestroy() {
    // clean up
    delete this.allItems;
    this.allItems = null;
    delete this.filteredItems;
    this.filteredItems = null;
    delete this.keywords;
    this.keywords = null;
  },
}
</script>

<style scoped lang="scss">
.void-filler {
  color: gray;
  text-align: center;
  font-size: 1.5rem;
  margin-top: 2.0rem;
}

ul {
  list-style-type: none;
  padding: 0;
}

text {
  padding-top: 7px;
}

.list__item {
  padding: 15px;
  // border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  // margin-bottom: 0.75em;

  &:nth-child(odd) {
    background-color: rgba(0, 0, 0, 0.03);
  }
}

.page {
  max-width: 800px;
}

/* overwrite bootstrap */
.list-group-item {
  padding: 0;
  padding-left: 15px;
  border: none;
  display: inline-flex;
  background-color: transparent;
}

.card {
  width: 100%;
  margin-bottom: 1.0rem;
}

.form-container {
  margin-bottom: 1.0rem;
}

/* pagination */
.btn {
  font-size: 12px;
  margin-top: 5px;
}

.btn-number {
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-size: 0.75em;
}

.btn-prev,
.btn-next {
  background-color: transparent;

  &:hover {
    background-color: transparent;
  }
}

.selected {
  background-color: darken(lightgray, 13%);
}

.clicked {
  color: #0060ff;
}

.card-header {
  padding: 0;
  border: none;
  background-color: transparent;
}

select {
  font-size: .9em;
  max-width: 70px;
}

.collapsing {
  width: 100%;
  overflow: unset;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked+.slider {
  background-color: #2196F3;
}

input:focus+.slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked+.slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

*[data-tooltip] {
  position: relative;
}

*[data-tooltip]::after {
  content: attr(data-tooltip);

  position: absolute;
  top: -20px;
  right: -20px;
  width: 150px;

  pointer-events: none;
  opacity: 0;
  -webkit-transition: opacity .15s ease-in-out;
  -moz-transition: opacity .15s ease-in-out;
  -ms-transition: opacity .15s ease-in-out;
  -o-transition: opacity .15s ease-in-out;
  transition: opacity .15s ease-in-out;

  display: block;
  font-size: 12px;
  line-height: 16px;
  background: #fefdcd;
  padding: 2px 2px;
  border: 1px solid #c0c0c0;
  box-shadow: 2px 4px 5px rgba(0, 0, 0, 0.4);

  z-index: 99;
}

*[data-tooltip]:hover::after {
  opacity: 1;
}

.nameDate {
  float: right;
}

.allergy-btn {
  margin-right: 5%;
  background-color: #b4b4e5;
  border-radius: 20px;
}

.add-allergy-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.inner-text-modal {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
}

.form-group {
  margin-bottom: 20px;
}

.form-group2 label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  font-size: 14px;
}

.form-control2 {
  display: block;
  width: 100%;
  height: 40px;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: none;
}

.btn-group {
  display: flex;
  justify-content: flex-end;
}

.btn-primary,
.btn-secondary {
  height: 40px;
  padding: 0 20px;
}
</style>
